import { SyncOutlined } from '@ant-design/icons';
import { Button, message, Modal } from 'antd';
import axios from 'axios';
import { BASE_URL } from 'constants/api';
import React, { useState } from 'react';

interface ContentBulkDistributionButtonProps {
  selectedList: number[];
}

const ContentBulkDistributionButton = ({ selectedList }: ContentBulkDistributionButtonProps) => {
  const [loading, setLoading] = useState(false);

  const handleBulkResync = () => {
    if (selectedList.length === 0) {
      alert('Please select at least one content');
      return;
    }

    Modal.confirm({
      title: 'Resync Distribution',
      content: `Do you want to resync distribution for ${selectedList.length} selected content(s)?`,
      okText: 'Resync',
      cancelText: 'Cancel',
      onOk: async () => {
        setLoading(true);
        try {
          const results = await Promise.allSettled(
            selectedList.map(id =>
              axios.post(`${BASE_URL}/api/v1/content/${id}/resync-distribution/`)
            )
          );
          const succeeded = results.filter(r => r.status === 'fulfilled').length;
          const failed = results.filter(r => r.status === 'rejected').length;
          if (failed === 0) {
            message.success(`Resync completed for ${succeeded} content(s)`);
          } else {
            message.warning(`Resync: ${succeeded} succeeded, ${failed} failed`);
          }
          window.location.reload();
        } catch (error) {
          console.error('Failed to resync distribution:', error);
          Modal.error({ title: 'Error', content: 'Failed to resync distribution', okText: 'Confirm' });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <Button
      key="bulk-resync"
      icon={<SyncOutlined spin={loading} />}
      loading={loading}
      onClick={handleBulkResync}
      size="small"
    >
      Resync Distribution
    </Button>
  );
};

export default ContentBulkDistributionButton;
